/**
 * My Beauty Suite — FAQ Single-Open Fix v4
 * Overrides accordion-disclosure to enforce one-open-at-a-time
 *
 * INSTALL:
 * 1. Assets → mbs-faq-one-open.js → paste → Save
 * 2. layout/theme.liquid → just above </body>:
 *    <script src="{{ 'mbs-faq-one-open.js' | asset_url }}" defer></script>
 */

(function () {
  'use strict';

  // Wait until Prestige's accordion-disclosure is defined, then patch it
  function patchAccordion() {
    var faqContainers = document.querySelectorAll('.faq__content');
    if (!faqContainers.length) return;

    faqContainers.forEach(function (container) {
      var allDetails = container.querySelectorAll('details');

      allDetails.forEach(function (details) {
        // Use MutationObserver to watch when 'open' attribute is ADDED
        var observer = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            if (
              mutation.type === 'attributes' &&
              mutation.attributeName === 'open' &&
              details.hasAttribute('open')
            ) {
              // This details just opened — close all others
              allDetails.forEach(function (other) {
                if (other !== details && other.hasAttribute('open')) {
                  // Remove open attribute
                  other.removeAttribute('open');
                  // Also flip aria-expanded
                  other.setAttribute('aria-expanded', 'false');
                  var summary = other.querySelector('summary');
                  if (summary) summary.setAttribute('aria-expanded', 'false');
                }
              });
            }
          });
        });

        observer.observe(details, { attributes: true, attributeFilter: ['open'] });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchAccordion);
  } else {
    patchAccordion();
  }

  document.addEventListener('shopify:section:load', patchAccordion);

})();